export default {
  de: {
    alternate: 'Ersatzmitglied',
    cashier: 'Kassier*in',
    cityCouncil: 'Stadtrat*rätin',
    council: 'Gemeinderat*rätin',
    councilBoard: 'Gemeindevorstand',
    fraction: 'Fraktionsvorsitzende*r',
    mayor: 'Bürgermeister*in',
    peoplesmayor: 'Volksbürgermeister*in',
    title: 'Gemeinderat',
    vicemayor: 'Vizebürgermeister*in',
  },
};
